import React from 'react';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';
import LabeledCheckbox from '../LabeledCheckbox.jsx';
import { setProjectFilterChanges } from '../../context/projectFilter.js';
import { useStateValue } from '../../context/state.jsx';

const FilterByChanges = () => {
	const [{ projectFilter }, dispatch] = useStateValue();
	const handleChangesChange = e => {
		dispatch(setProjectFilterChanges(e.target.checked));
	};

	return (
		<Panel
			className={classnames({activeFilter: projectFilter.changes})}>
			<Panel.Heading>
				<Panel.Title toggle>Changes</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<LabeledCheckbox
						text="Changed since import"
						textClass={projectFilter.changes ? 'isChecked' : ''}
						checked={projectFilter.changes}
						onChange={handleChangesChange} />
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByChanges;
